import {
  apiGetUserSchool,
  apiUpdateSchoolDetails,
  apiRemoveAvatar,
  apiUploadAvatar,
  apiRemoveCover,
  apiUploadCover
} from '../../common/api/school'

const fetchSchool = schoolId => ({
  requestPrefix: 'SCHOOL:FETCH',
  params: { schoolId },
  request: () =>
    apiGetUserSchool({
      include:
        'account.teacher_type.school,account.teacher_type.school.names,account.teacher_type.school.urn,account.teacher_type.school.address,account.teacher_type.school.contact_details,account.teacher_type.school.counters,account.teacher_type.school.logo,account.teacher_type.school.background_image,account.teacher_type.school.settings,account.teacher_type.school.website,account.teacher_type.school.twitter_handler,account.teacher_type.school.work_counters'
    })
})

const updateSchool = (schoolId, data) => ({
  requestPrefix: 'SCHOOL:UPDATE',
  params: { schoolId, data },
  request: () => apiUpdateSchoolDetails(schoolId, data)
})

const uploadAvatar = (schoolId, img) => ({
  requestPrefix: 'SCHOOL:UPLOAD_AVATAR',
  params: { schoolId, img },
  request: () => apiUploadAvatar(schoolId, img)
})

const removeAvatar = schoolId => ({
  requestPrefix: 'SCHOOL:REMOVE_AVATAR',
  params: { schoolId },
  request: () => apiRemoveAvatar(schoolId)
})

const uploadCover = (schoolId, img) => ({
  requestPrefix: 'SCHOOL:UPLOAD_COVER',
  params: { schoolId, img },
  request: () => apiUploadCover(schoolId, img)
})

const removeCover = schoolId => ({
  requestPrefix: 'SCHOOL:REMOVE_COVER',
  params: { schoolId },
  request: () => apiRemoveCover(schoolId)
})

export {
  fetchSchool,
  updateSchool,
  uploadAvatar,
  removeAvatar,
  uploadCover,
  removeCover
}
